import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { makeSelectDocumentosByItemId } from '@store/selectors/documentosSelector';

export const DocumentCounter = ({ idSolicitacaoProcessoItem }) => {
  // memoize the selector instance
  const selector = useMemo(
    () => makeSelectDocumentosByItemId(idSolicitacaoProcessoItem),
    [idSolicitacaoProcessoItem]
  );

  const documents = useSelector(selector);
  const total = documents?.length || 0;
  const result = total === 1 ? "arquivo" : "arquivos";

  return <span className="small">{total} {result}</span>;
};
